import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = "/api";
const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

/**
 * Lê /api/reports/reviews?days=N. Retorna `{ data, loading, refresh }`.
 * Refetch automático sempre que `days` muda. `refresh()` força reload manual.
 */
export function useReviewsReport(days) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/reports/reviews?days=${days}`, authHeader());
      setData(res.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao carregar relatório");
    } finally {
      setLoading(false);
    }
  }, [days]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  // Update otimista do flag hidden_from_avg de uma review. Não recalcula
  // avg_geral/distribuição localmente — deixa pro próximo refresh() do servidor.
  const applyLocal = (reviewId, hidden) => {
    setData((d) =>
      d
        ? {
            ...d,
            reviews: (d.reviews || []).map((r) =>
              r.id === reviewId ? { ...r, hidden_from_avg: hidden } : r,
            ),
          }
        : d,
    );
  };

  return { data, loading, refresh: fetch, applyLocal };
}
